// §4.4 partial — admin/stats routes.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AdminStatsPage = lazyWithRetry(() => import("./pages/AdminStatsPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [{ path: "/admin/stats", Component: AdminStatsPage }],
  },
];

export default routes;
